import { Button, IconArrowLeft, IconArrowRight, IconColumns, Loader, Wrapper } from '@screentone/core';

import { RevisionSelector } from 'components/revision-selector/RevisionSelector';
import styles from './PublishHistory.module.scss';

interface PublishHistoryToolbarProps {
  onPrev: () => void;
  onNext: () => void;
  hasPrev: boolean;
  hasNext: boolean;
  isAtPrevBoundary: boolean;
  isAtNextBoundary: boolean;
  disabledNavigationInEditMode: boolean;
  isFetchingScheduledContent: boolean;
  isAllowedToCompare: boolean;
  onOpenCompare: () => void;
  selectedDate: number | null;
  onSelectRevision: (publishUtc?: number) => void;
  onSelectDate: (date: number) => void;
  onReset: () => void;
  dateGroupsScheduled: number[];
  dateGroupsPublished: number[];
  areRevisionsLoading: boolean;
}

export const PublishHistoryToolbar = ({
  onPrev,
  onNext,
  hasPrev,
  hasNext,
  isAtPrevBoundary,
  isAtNextBoundary,
  disabledNavigationInEditMode,
  isFetchingScheduledContent,
  isAllowedToCompare,
  onOpenCompare,
  selectedDate,
  onSelectRevision,
  onSelectDate,
  onReset,
  dateGroupsScheduled,
  dateGroupsPublished,
  areRevisionsLoading
}: PublishHistoryToolbarProps) => {
  const prevDisabled =
    !hasPrev || disabledNavigationInEditMode || isFetchingScheduledContent || isAtPrevBoundary || areRevisionsLoading;
  const nextDisabled =
    !hasNext || disabledNavigationInEditMode || isFetchingScheduledContent || isAtNextBoundary || areRevisionsLoading;

  return (
    <Wrapper className={styles.navigator}>
      <Button tertiary onClick={onPrev} disabled={prevDisabled} data-testid="page-publish-history-previous-button">
        {isAtPrevBoundary ? <Loader size="md" margin={{ right: 'sm' }} /> : <IconArrowLeft margin={{ right: 'sm' }} />}
        Previous
      </Button>
      {isAllowedToCompare && (
        <Button tertiary onClick={onOpenCompare} disabled={prevDisabled}>
          <IconColumns margin={{ right: 'sm' }} />
          Compare with Previous
        </Button>
      )}
      <RevisionSelector
        selectedDate={selectedDate}
        onSelectRevision={onSelectRevision}
        onSelectDate={onSelectDate}
        onReset={onReset}
        dateGroups={[
          {
            title: 'Scheduled pages',
            type: 'scheduled',
            dates: dateGroupsScheduled
          },
          {
            title: 'Published Pages',
            type: 'published',
            dates: dateGroupsPublished
          }
        ]}
        disabled={disabledNavigationInEditMode}
        areRevisionsLoading={areRevisionsLoading}
      />
      <Button tertiary onClick={onNext} disabled={nextDisabled} data-testid="page-publish-history-next-button">
        Next
        {isAtNextBoundary ? <Loader size="md" margin={{ left: 'sm' }} /> : <IconArrowRight margin={{ left: 'sm' }} />}
      </Button>
    </Wrapper>
  );
};
